import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
 
const withRouter = WrappedComponent => props => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <WrappedComponent
      {...props}
      navigate ={ navigate }
      params={params}
      location={location}
    />
  );
};
 
export default withRouter;